<template>
  <div id="supplierEditWrapper">
    <div class="columns">
      <div class="column">
        <div class="notification" v-show="loading">Laden...</div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-fifth">
        <p><router-link :to="{ name: 'suppliers' }"><span class="icon"><i class="fas fa-chevron-left"></i></span> Terug</router-link></p>
      </div>

      <div class="column is-four-fifths-table is-half-desktop">
        <div class="card">

          <http-messages :success="success" :errors="errors"></http-messages>

          <header class="card-header">
            <p class="card-header-title">Bedrijfsgegevens</p>
          </header>

          <div class="card-content">
            <template v-if="isAdmin">
              <label for="user" class="label">Contactpersoon</label>

              <div class="field has-addons">
                <div class="select">
                  <select class="is-radiusless" name="user" v-model="supplier.user_id">
                    <option v-for="user in users" :value="user.id">{{ user.firstname }} {{ user.lastname }}</option>
                  </select>
                </div>

                <div class="control">
                  <button
                    class="button is-info is-radiusless"
                    @click="sendInvite(supplier.id)"
                    :class="{ 'is-loading': sending, 'is-success': inviteSent, 'is-danger': inviteSent === false }"
                    type="button"
                  >Uitnodiging sturen</button>
                </div>
              </div>

              <hr/>

            </template>

            <div class="field">
              <label for="name" class="label">Bedrijfsnaam</label>

              <div class="control">
                <input
                  class="input"
                  type="text"
                  name="name"
                  :class="{ 'is-danger': errors.name }"
                  v-model="supplier.name">
              </div>

              <p v-for="message in errors.name" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="logo" class="label">Logo</label>

              <div v-show="supplier.logo" class="is-clipped">
                <figure class="image is-128x128">
                  <button class="delete is-small" @click="removeImage"></button>

                  <img :src="supplier.logo">
                </figure>
              </div>

              <div class="control">
                <v-uploader @done="uploadDone" :preview="false" button-text="Nieuw logo uploaden" file-size-limit="2MB"></v-uploader>
              </div>

              <ul class="upload-rules">
                <li>Logo's mogen maximaal 2MB groot zijn</li>

                <li>Toegestane bestanden zijn .jpg en .png</li>
              </ul>
            </div>

            <div class="field">
              <label for="address" class="label">Adres</label>

              <div class="control">
                <input
                  class="input"
                  type="text"
                  name="address"
                  :class="{ 'is-danger': errors.address }"
                  v-model="supplier.address">
              </div>

              <p v-for="message in errors.address" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="zip" class="label">Postcode</label>

              <div class="control">
                <input
                  class="input"
                  type="text"
                  name="zip"
                  :class="{ 'is-danger': errors.zip }"
                  v-model="supplier.zip">
              </div>

              <p v-for="message in errors.zip" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="city" class="label">Plaats</label>

              <div class="control">
                <input
                  class="input"
                  type="text"
                  name="city"
                  :class="{ 'is-danger': errors.city }"
                  v-model="supplier.city">
              </div>

              <p v-for="message in errors.city" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="phone" class="label">Telefoon</label>

              <div class="control">
                <input
                  class="input"
                  type="text"
                  name="phone"
                  :class="{ 'is-danger': errors.phone }"
                  v-model="supplier.phone">
              </div>

              <p v-for="message in errors.phone" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="email" class="label">E-mail</label>

              <div class="control">
                <input
                  class="input"
                  type="text"
                  name="email"
                  :class="{ 'is-danger': errors.email }"
                  v-model="supplier.email">
              </div>

              <p v-for="message in errors.email" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="www" class="label">Website</label>

              <div class="control">
                <input
                  class="input"
                  type="text"
                  name="www"
                  :class="{ 'is-danger': errors.www }"
                  v-model="supplier.www">
              </div>

              <p v-for="message in errors.www" class="help is-danger">{{ message }}</p>
            </div>
          </div>

          <footer class="card-footer">
            <button
              class="button is-text card-footer-item"
              @click="save"
              :class="{ 'is-loading': loading }"
              :disabled="!supplier.name">
              Opslaan
            </button>
          </footer>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-four-fifths-tablet is-half-desktop is-offset-one-fifth">
        <button v-if="isAdmin" type="button" class="button is-danger is-fullwidth" @click="delSupplier">Leverancier verwijderen</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import HttpMessages from '@/components/http/HttpMessages'

  export default {
    components: {
      HttpMessages
    },
    data () {
      return {
        supplier: {},
        users: {},
        loading: false,
        errors: {},
        success: false,
        failed: false,
        sending: false,
        inviteSent: null,
        tooLarge: false,
        invalidExtension: false
      }
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      params () {
        return this.$store.getters.params
      }
    },
    created () {
      if (this.isAdmin) {
        this.loadUsers()
        if (this.$route.params.id) this.fetchData(this.$route.params.id)
      } else if (this.$store.getters.accountData.supplier) {
        this.supplier = this.$store.getters.accountData.supplier
      }
    },
    updated () {
    },
    beforeDestroy () {
      this.supplier = {}
    },
    methods: {
      isEmpty(obj) {
        for(var key in obj) {
          if (obj.hasOwnProperty(key)) {
            return false
          }
        }

        return true
      },
      fetchData (id) {
        this.loading = true
        axios
          .get('/suppliers/' + id)
          .then(response => {
            this.loading = false
            this.supplier = response.data
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          })
      },
      // TODO: This endpoint needs to be protected by a login token
      loadUsers () {
        this.loading = true
        axios
          .get('/users')
          .then(response => {
            this.loading = false
            this.users = response.data
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message
          })
      },
      save () {
        this.errors = {}
        this.loading = true
        this.success = false

        if (this.supplier.id) {
          axios
            .put('/suppliers/' + this.supplier.id,
              this.supplier,
            )
            .then(response => {
              this.loading = false
              this.success = true
            })
            .catch(error => {
              this.loading = false
              this.errors = error.response.data.errors
            })
        } else {
          axios
            .post('/suppliers',
              this.supplier,
            )
            .then(response => {
              this.loading = false
              this.success = true
              this.supplier = response.data
            })
            .catch((error) => {
              this.loading = false
              this.errors = error.response.data.errors
            })
        }
      },
      sendInvite (id) {
        this.save() // Save any changes first so we're sure the invite goes to the right user

        this.sending = true
        this.success = this.failed = false
        axios
          .post('/suppliers/invite',
            { id: id },
          )
          .then(response => {
            this.sending = false
            this.inviteSent = true
          })
          .catch(error => {
            this.sending = false
            this.inviteSent = false
          })
      },
      delSupplier () {
        axios
          .delete('/suppliers/' + this.supplier.id)
          .then(response => {
            this.$router.push({name: 'suppliers'})
          })
          .catch((error) => {
            console.log(error)
          })
      },
      uploadDone (files) {
        this.clearErrors()
        if (files[0].success) this.supplier.logo = files[0].url
      },
      removeImage () {
        this.supplier.logo = null
      },
      clearErrors () {
        this.tooLarge = this.invalidExtension = false
      }
    }
  }
</script>

<style scoped>
  .card {
    margin-top: 30px;
  }

  .button.is-text {
    text-decoration: none;
  }

  .button {
    line-height: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/suppliers/SupplierEdit.vue